import Styled, { css } from 'styled-components';

import { cssDeclaration } from '../../Utils';
import { IInputMaxWidth } from '../common';
import { media } from '../../../../lib/StyledComponents/StyledComponents';

export interface IOptionListItem {
  isActive?: boolean;
}

export const OptionList = Styled.ul<IInputMaxWidth>`
  position: absolute;

  width: 100%;
  overflow-y: scroll;

  ${({ theme: { themeTwo }, maxWidth }) => {
    const { form: { autoComplete: { list }}} = themeTwo;

    return css`
      z-index: ${themeTwo.global.zIndex.high};
      /* background-color */ ${cssDeclaration(themeTwo, 'background-color', list.backgroundColor)};
      /* box-shadow */ ${cssDeclaration(themeTwo, 'box-shadow', list.shadow)};
      /* height */ ${cssDeclaration(themeTwo, 'height', { max: list.height.max })};

      ${maxWidth && css`
        ${media.small`
          max-width: ${maxWidth};
        `}
      `}
    `;
  }}
`;

const CommonOptionListItemStyles = css`
  ${({ theme: { themeTwo }}) => {
    const { form: { autoComplete: { listItem }}} = themeTwo;

    return css`
      line-height: ${listItem.font.lineHeight};

      /* color */ ${cssDeclaration(themeTwo, 'color', listItem.font.color)};
      /* font-size */ ${cssDeclaration(themeTwo, 'font-size', listItem.font.size)};
      /* padding */ ${cssDeclaration(themeTwo, 'padding', listItem.padding)};

      &:first-of-type {
        /* margin */ ${cssDeclaration(themeTwo, 'margin', { top: listItem.margin.top })};
      }

      &:last-of-type {
        /* margin */ ${cssDeclaration(themeTwo, 'margin', { bottom: listItem.margin.bottom })};
      }
    `;
  }}
`;

export const OptionListItem = Styled.li<IOptionListItem>`
  ${CommonOptionListItemStyles}
  cursor: pointer;

  ${({ theme: { themeTwo }, isActive }) => {
    const { form: { autoComplete: { listItem }}} = themeTwo;

    return css`
      ${isActive && css`
        /* color */ ${cssDeclaration(themeTwo, 'color', listItem.active.font.color)}
        /* background-color */ ${cssDeclaration(themeTwo, 'background-color', listItem.active.backgroundColor)}
      `};

      &:hover {
        /* color */ ${cssDeclaration(themeTwo, 'color', listItem.active.font.color)}
        /* background-color */ ${cssDeclaration(themeTwo, 'background-color', listItem.active.backgroundColor)}
      }
    `;
  }}
`;

export const OptionListItemNoResults = Styled.li`
  ${CommonOptionListItemStyles}
`;

export const OptionListItemHeader = Styled.li`
  ${CommonOptionListItemStyles}

  ${({ theme: { themeTwo }}) => {
    const { form: { autoComplete: { listItemHeader }}} = themeTwo;

    return css`
      font-weight: ${listItemHeader.font.weight};
      line-height: ${listItemHeader.font.lineHeight};
      /* color */ ${cssDeclaration(themeTwo, 'color',  listItemHeader.font.color)}
      /* font-size */ ${cssDeclaration(themeTwo, 'font-size', listItemHeader.font.size)};
    `;
  }}
`;
